module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-maintenance-system-report/master-maintenance-system-report.component.scss
// module id = ./src/app/master/master-maintenance-system-report/master-maintenance-system-report.component.scss
// module chunks = main